import { render } from "./TokenManage.vue?vue&type=template&id=043c00b8&scoped=true"
import script from "./TokenManage.vue?vue&type=script&lang=js"
export * from "./TokenManage.vue?vue&type=script&lang=js"

import "./TokenManage.vue?vue&type=style&index=0&id=043c00b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043c00b8"]])

export default __exports__